// extracted by mini-css-extract-plugin
module.exports = {"fileStatusContainer":"mnrFileHistory_fileStatusContainer__30Bin","loadMoreBtnContainer":"mnrFileHistory_loadMoreBtnContainer__1Fwe3"};